import(/* webpackMode: "eager" */ "/app/app/id/[sketchId]/view/page.tsx");
